import * as React from "react";
import "./infoModule.scss";
import IconWrapper from "../../atoms/Icon/IconWrapper";

interface IProps {
	/**
	 * Header icon name.
	 */
	icon: string;
	/**
	 * Header text.
	 */
	title: string;
	/**
	 * Header action icon name.
	 */
	actionIcon?: string;
	/**
	 * Header action icon callback.
	 * @param {React.MouseEvent<SVGSVGElement>} evt
	 */
	onActionIconClick?: (evt: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * Flag for disable action icon.
	 */
	actionDisabled?: boolean;
	/**
	 * Header action extra icon name.
	 */
	actionExtraIcon?: string;
	/**
	 * Header action icon extra callback.
	 * @param {React.MouseEvent<SVGSVGElement>} evt
	 */
	onActionExtraIconMouseOver?: (evt: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * On mouse out
	 * @param event
	 */
	onActionExtraIconMouseOut?: (event: React.MouseEvent<SVGSVGElement>) => void;
}

export default class InfoModule extends React.Component<IProps, {}> {
	render() {
		return (
			<div className={"m-info-module"}>
				<div className={"m-info-module_header"}>
					<IconWrapper icon={this.props.icon} variant={"lighterBlue"} size={18}/>
					{this.props.title}
					<span className={"m-info-module_header_actions"}>
						{this.props.actionExtraIcon &&
						<IconWrapper icon={this.props.actionExtraIcon}
									 variant={"blue"}
									 size={24}
									 onMouseOver={this.props.onActionExtraIconMouseOver}
									 onMouseOut={this.props.onActionExtraIconMouseOut}
									 transform={"rotate(180)"}/>}
						{this.props.onActionIconClick &&
						<IconWrapper icon={this.props.actionIcon} variant={"lighterBlue"} size={18}
									 onClick={this.props.onActionIconClick}
									 disabled={this.props.actionDisabled}/>
						}
					</span>
				</div>
				<div className={"m-info-module_content"}>
					{this.props.children}
				</div>
			</div>
		);
	}
}
